import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (process.env.NODE_ENV == 'production') {
Raven
    .config('https://0518ac876cdd4d1e8441675ed20c035a@sentry.julanling.com/81')
    .addPlugin(RavenVue, Vue)
    .install();
}
